import axios from "axios";
import { config } from "@/config.js";

export default {
  data() {
    return {
      seo: null,
      canonical: null,
      gtm: null
    };
  },
  async created() {
    const lang = window.location.pathname;
    const url = lang.split("/");
    const locale = url[1];

    if (locale.length > 0) {
      this.seoUrl = `${config.SEO_API}${lang}/global-data`;
      this.getUrl = `${config.API}${lang}/vin`;
    } else {
      this.seoUrl = `${config.SEO_API}/global-data`;
      this.getUrl = `${config.API}/vin`;
    }
    try {
      await axios.get(`${this.getUrl}`).then(response => {
        this.canonical = location.origin;
        this.seo = response.data.seo;
      });
      const { data } = await axios.get(`${this.seoUrl}`);
      this.gtm = data;
      this.appendAdditionalScripts();
      // console.log(data);
      return;
    } catch (e) {
      // console.log(e);
    }
  },
  methods: {
    appendAdditionalScripts() {
      // console.log(123);
      const scripts = this.gtm;

      const range = document.createRange();

      // append to head
      if (scripts.hasOwnProperty("scriptHead")) {
        // console.log(3333);
        const head = document.getElementsByTagName("head")[0];

        range.setStart(head, 0);

        head.appendChild(range.createContextualFragment(scripts.scriptHead));
      }

      // append to body
      if (scripts.hasOwnProperty("scriptBody")) {
        // console.log(111);
        const body = document.body;

        body.appendChild(range.createContextualFragment(scripts.scriptBody));
      }
    }
  }
  // metaInfo() {
  //   if (this.seo) {
  //     return {
  //       title: this.seo.title || "",
  //       meta: [
  //         {
  //           name: "description",
  //           content: this.seo.description || ""
  //         },
  //         {
  //           property: "og:title",
  //           content: this.seo.ogtitle || ""
  //         },
  //         {
  //           property: "og:description",
  //           content: this.seo.ogdescription || ""
  //         },
  //         {
  //           property: "og:image",
  //           content: this.seo.image || ""
  //         },
  //         {
  //           name: "twitter:title",
  //           content: this.seo.ogtitle || ""
  //         },
  //         {
  //           name: "twitter:description",
  //           content: this.seo.ogdescription || ""
  //         },
  //         {
  //           name: "twitter:image",
  //           content: this.seo.image || ""
  //         },
  //         {
  //           property: "og:url",
  //           content: this.canonical || ""
  //         }
  //       ],
  //       links: [
  //         {
  //           rel: "canonical",
  //           href: this.canonical || ""
  //         }
  //       ]
  //     };
  //   } else {
  //     return {};
  //   }
  // }
};
